<template>
  <div class="app">
    <div class="radio">
      <h3>
        项目开始时间：
      </h3>
      <el-radio-group v-model="reverse">
        <el-radio :label="false">正序</el-radio>
        <el-radio :label="true">倒序</el-radio>
      </el-radio-group>
    </div>

    <el-timeline :reverse="reverse">
      <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :color="activeColor"
          :timestamp="activity.timestamp">
        {{ activity.content }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
export default {
  name: "Schedule",
  data() {
    return {
      reverse: false,
      activities: [
        {
          content: '大类项目： 冰壶',
          timestamp: '2022-02-02'
        },
        {
          content: '大类项目： 冰球',
          timestamp: '2022-02-03'
        },
        {
          content: '大类项目： 自由滑雪',
          timestamp: '2022-02-03'
        },
        {
          content: '开幕式',
          timestamp: '2022-02-04'
        },
        {
          content: '大类项目： 花样滑雪',
          timestamp: '2022-02-04'
        },
        {
          content: '大类项目： 速度滑冰',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 短道竞速',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 跳台滑雪',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 越野滑雪',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 冬季两项',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 单板滑雪',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 自由式滑雪',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 雪橇',
          timestamp: '2022-02-05'
        },
        {
          content: '大类项目： 高山滑雪',
          timestamp: '2022-02-06'
        },
        {
          content: '高山滑雪\n' +
              '技术项目\n' +
              ' 大回转\n' +
              '回转\n' +
              '混合团体\n' +
              '全能',
          timestamp: '2022-02-07'
        },
        {
          content: '大类项目： 钢架雪车',
          timestamp: '2022-02-10'
        },
        {
          content: '大类项目： 雪车',
          timestamp: '2022-02-13'
        },
        {
          content: '闭幕式',
          timestamp: '2022-02-20'
        }
      ],
      activeColor: '#0bbd87'
    }
  }
}
</script>

<style scoped lang="less">
.app{
  position: relative;
  width: 100%;
  height: 100%;
}
.radio{

  h3{
    text-align: left;
    text-indent: 2em;
  }
  .el-radio-group{
    margin-bottom: 20px;
  }
}


.el-timeline{


  .el-timeline-item{
    text-align: left;
    text-indent: 2em;
  }
}
</style>